import React from 'react';
import PropTypes from 'prop-types';

import { Select } from 'antd';
import SelectOrAdd from '../common/inputs/SelectOrAdd';

export default function CertificationTypeInput({
  value,
  onChange,
  options,
  onAddNew,
  validIds,
  canAddNew,
}) {
  if (!validIds.has(value)) {
    onChange(null);
  }

  if (!canAddNew) {
    return (
      <Select
        allowClear
        showSearch
        placeholder="Select a certification type"
        value={value}
        onChange={onChange}
        optionFilterProp="label"
        style={{ width: '100%' }}
        options={options.map(({ id, title }) => ({
          value: id,
          label: title,
        }))}
      />
    );
  }

  return (
    <SelectOrAdd
      type="a certification type"
      options={options}
      value={value}
      onSelect={onChange}
      onAddNew={(newType) => {
        onAddNew(newType);
        onChange(newType);
      }}
      dropdownMatchSelectWidth
      dropdownWidth={350}
      style={{ width: '100%' }}
    />
  );
}

CertificationTypeInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
  })),
  onAddNew: PropTypes.func,
  validIds: PropTypes.instanceOf(Set).isRequired,
  canAddNew: PropTypes.bool,
};

CertificationTypeInput.defaultProps = {
  value: null,
  onChange: null,
  options: [],
  onAddNew: null,
  canAddNew: false,
};
